import { AuthCheckDtoRole } from '@/api-client/api';

export function isUserAdmin(userRole: AuthCheckDtoRole | null) {
    return userRole === AuthCheckDtoRole.admin;
}